export enum QUIZ_QUESTION_TYPE {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
